import React, { useState, useEffect } from 'react';
import './App.css';
/* import Home from './screens/Home'; */
import DataCatalog from './screens/DataCatalog';
import GTFSDetails from './components/GTFSDetails';
import GTFSDetailsNB from './components/GTFSDetailsNB';
import RegisterScreen from './screens/RegisterScreen';


function App() {
  /* const [currentPage, setCurrentPage] = useState('/'); */
  const [currentPage, setCurrentPage] = useState('/cataleg-dades');

  function useCustomLocation() {
    const [location, setLocation] = useState(window.location);
  
    useEffect(() => {
      const handleLocationChange = () => {
        setLocation(window.location);
      };
  
      window.addEventListener('popstate', handleLocationChange);
  
      return () => {
        window.removeEventListener('popstate', handleLocationChange);
      };
    }, []);
  
    return location;
  }
  
  const location = useCustomLocation();
 const location2 = localStorage.getItem('locale')
  useEffect(() => {

    const searchParams = new URLSearchParams(location.search);
    console.log(searchParams.get('locale'));
    console.log(location2);
    console.log(window.localStorage);

    const handlePopState = () => {
      /* const path = window.location.pathname.replace('/opendata', '') || '/'; */
      const path = window.location.pathname.replace('/opendatafront', '') || '/cataleg-dades' ;
      setCurrentPage(path);
    };

    window.addEventListener('popstate', handlePopState);

    // Inicializar el estado actual de la ruta
    handlePopState();

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location,location2]);

  const navigate = (page) => {
    setCurrentPage(page);
    window.history.pushState(null, '', `/opendatafront${page}`);
  };                 

  const renderPage = () => {
    /* switch (currentPage) {
      case '/':
        return <Home navigate={navigate} />;
      case '/cataleg-dades':
        return <DataCatalog navigate={navigate} />;
      case '/cataleg-dades-estatic':
        return <GTFSDetails navigate={navigate} />;
      default:
        return <Home navigate={navigate} />;
    } */
    switch (currentPage) {
      case '/':
      case '/cataleg-dades':
        return <DataCatalog navigate={navigate} />;
      case '/cataleg-dades-estatic':
        return <GTFSDetails navigate={navigate} />;
        case '/cataleg-dades-estaticnb':
        return <GTFSDetailsNB navigate={navigate} />;
      case '/cataleg-dades-rt':
        return <RegisterScreen navigate={navigate} />;  
      default:
        return <DataCatalog navigate={navigate} />;
    }
  };

  return (
    <div>
      {renderPage()}
    </div>
  );
}

export default App;